<span>
  {{
    'Analysis::GenAI.Project.DeletionCompletedNotificationMessage'
      | abpLocalization : payloadData?.name
  }}
</span>
